import { render } from "./expertBookingModal.vue?vue&type=template&id=4e2b6116&ts=true"
import script from "./expertBookingModal.vue?vue&type=script&lang=ts"
export * from "./expertBookingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__